import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  container: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "24px",
    padding: "0 50px",
  },

  title: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    color: colors.blue500,
    textAlign: "center",
  },

  loading: {
    width: "25% !important",
    height: "100% !important",
    color: colors.brandBlue500,
    backgroundColor: colors.brandBlue50,
    borderRadius: "50%",
    padding: "22px",
  },

  information: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    color: colors.gray600,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    textAlign: "center",
  },

  tryAgainButton: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    color: colors.blue500,
    padding: "0 4px",
  },

  modalSize: {
    width: "35%",
    maxWidth: "430px",
  },

  warningMessage: {
    font: "500 14px Inter",
    color: "#308CDB",
  },
}));

export default styles;
